import dynamic from 'next/dynamic';
import { getNavigationUrl } from '../../../../utils';
import { Widget } from '../../../../apiService';

const LiveCardList = dynamic(() => import('./LiveCardList'));

const LiveCarouselWidget = ({ widget, afterTeaser }: { widget: Widget<'live_channel'>; afterTeaser?: boolean }) => {
  const {
    configuration: { items, navigation_configuration },
    display_title,
  } = widget;
  const more = getNavigationUrl(navigation_configuration);
  if (!items.length) return null;

  return <LiveCardList items={items} title={display_title} more={more} afterTeaser={afterTeaser} />;
};

export default LiveCarouselWidget;
